<template>
  <div>
    <v-radio-group
      :row="true"
      v-model="val"
      @change="changeValue"
      class="sdk_filter"
    >
      <v-radio :label="$t('all')" value=""/>
      <v-radio :label="$t('Pro Apps')" value="no_sdk"/>
      <v-radio label="SDK" value="sdk"/>
    </v-radio-group>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
  },
  data () {
    return {
      val: ''
    }
  },
  methods: {
    changeValue () {
      this.$emit('input', this.val)
      this.$emit('change', this.val)
    }
  }
}
</script>
<style lang="sass">
.sdk_filter
  float: right
  label
    margin-bottom: 0
</style>



// WEBPACK FOOTER //
// SdkFilter.vue?466e30ca